export enum languages {
  vi = 'vi',
  en = 'en',
}

export enum socialLogin {
  zalo = 'zalo',
  google = 'google',
  facebook = 'facebook',
}

export enum eGeneralInfo {
  phone = 'phone',
  mobile = 'mobile',
  email = 'email',
  company_name = 'company_name',
  address = 'address',
  logo = 'logo',
  meta_description = 'meta_description',
  seo_title = 'seo_title',
  facebook_page = 'facebook_page',
  twitter_page = 'twitter_page',
  work_time = 'work_time',
  youtube_page = 'youtube_page',
  online_gov_register = 'online_gov_register',
  google_analytic_id = 'google_analytic_id',
  logo_svg = 'logo_svg',
  linkedin_page = 'linkedin_page',
  company_info = 'company_info',
  instagram_page = 'instagram_page',
  tiktok_page = 'tiktok_page',
  menu_color = 'menu_color',
  login_image = 'login_image',
  login_image_mobile = 'login_image_mobile',
  bank_info = 'bank_info',
  popup = 'popup',
  popup_image = 'popup_image',
  order_online_completed = 'order_online_completed',
  popup_recruitment = 'popup_recruitment',
  order_online_completed_no_image = 'order_online_completed_no_image',
  not_found_image = 'not_found_image',
  exchange_rate = 'exchange_rate',
  tax = 'tax',
  map_link = 'map_link',
  phone_no_icon = 'phone_no_icon',
  global_news_css = 'global_news_css',
  vat_calculation = 'vat_calculation',
}

export enum DeliveryCode {
  shop = 'buy_at_shop',
  fast = 'fast_delivery',
  express = 'express_delivery',
  tech = 'tech_delivery',
}

export enum DeliveryCodeNew {
  buy_at_shop = 'buy_at_shop', // mua tại cửa hàng
  fast_delivery = 'fast_delivery', // giao hàng trong vòng 16 giờ làm việc
  express_delivery = 'express_delivery', // chuyển phát nhanh
  tech_delivery = 'tech_delivery', // xe ôm công nghệ
  ahamove = 'ahamove', // Ahamove
}

export enum PaymentCode {
  momo = 'momo',
  vnpay = 'vnpay',
  cash = 'cash',
  cod = 'cod',
  atm = 'atm',
  debt = 'debt',
  paypal = 'paypal',
  order_error = 'order_error', // hàng lỗi
  consumable_supplies = 'consumable_supplies', // vật tư tiêu hao
}

export enum Revalidate {
  ONE_MINUTE = 60,
  FIVE_MINUTES = 300,
  TEN_MINUTES = 600,
  ONE_HOUR = 3600,
}

export enum CommentType {
  product = 'Product',
  article = 'Article',
  page = 'Page',
  service = 'Service',
}

export enum Vat {
  MINIMUN_AMOUNT = 500000, // 5 trăm nghìn đồng
}

export enum SepayFee {
  FIXED_FEE = 450, // 450 vnđ
}
